import { Types } from 'index.js'
import type { FindOptions } from '../model'
import { default as Model, Query, toQueryAndOptions, Feature as ModelFeature } from '../model'
import Aeppic, { AeppicInterface } from './aeppic.js'
import { QueryCache } from './query-cache.js'
import { CommandAeppicInterface } from './commands/executor.js'
// import { Query } from 'model/index.js'

export type CachedQueryInterface = CommandAeppicInterface

export function wrapInCachedQueryInterface<T extends CachedQueryInterface>(instance: T) {
  const handler = new CachedAeppicHandler<T>(instance)
  return new Proxy(instance, handler) as CachedQueryInterface
}

interface Caches {
  findCache: QueryCache
}

class CachedAeppicHandler<T extends CachedQueryInterface> implements ProxyHandler<T> {
  caches: Caches

  constructor(instance: T, caches?: Caches) {
    this.caches = caches
      ? caches
      : ({
          findCache: new QueryCache({ allQueries: true }, instance.find.bind(instance)),
        } as Caches)
  }

  get(instance: T, propertyKey: string, receiver: any) {
    switch (propertyKey) {
      case 'find': {
        return async (
          queryArgument: string | Query.Query | Query.QueryBuilder,
          param1?: string | FindOptions,
          param2?: FindOptions
        ): Promise<Types.Document[]> => {
          const { query, options } = toQueryAndOptions(queryArgument, param1, param2)
          return await this.caches.findCache.find(query, options)
        }
      }
      case 'findOne': {
        return async (
          queryArgument: string | Query.Query | Query.QueryBuilder,
          param1?: string | FindOptions,
          param2?: FindOptions
        ): Promise<Types.Document> => {
          const { query, options } = toQueryAndOptions(queryArgument, param1, param2)
          const limitedOptions = { ...options, size: 1 }
          const documents = await this.caches.findCache.find(query, limitedOptions)
          return documents[0]
        }
      }
      default:
        return Reflect.get(instance, propertyKey, receiver)
    }
  }
}
